<template>
  <nav class="mobile_menu" id="menu">
    <div class="clearfix">
      <div class="mobile_only">
        <div class="m_head_login-before" v-if="!userLogged">
          <a href="#" @click.prevent="openLogin">
            כניסה לחשבון >
            <user-svg></user-svg>
          </a>
        </div>
        <div class="m_head_login" v-if="userLogged">
          <router-link :to="{name: 'myaccount'}">
            <span class="m_login_name">
              היי {{userLoggedInfo.firstname}}
              <user-svg></user-svg>

              <span
                class="m_login_address"
              >{{userLoggedInfo.address}} </span>
            </span>
            <span class="m_login_link">החשבון שלי</span>
          </router-link>
            <span class="m_logout_link" @click="userLogout">התנתק</span>
        </div>
        <div class="m_my_btns clearfix">
          <div class="right m_my_btn">
            <router-link
              :to="{
                        path: globalOption.pages.favs.replace(
                          wpData.home_url,
                          ''
                        )
                      }"
            >
              <span class="favorite_num">{{storedFavs.length}}</span>
              <heart-svg></heart-svg>מועדפים
            </router-link>
          </div>
          <div class="right m_my_btn">
            <router-link
              :to="{
                        path: '/my-account/history',
                        params: { state: 'history' }
                      }"
            >
              <refresh-svg></refresh-svg>שחזור הזמנה
            </router-link>
          </div>
          <div class="right m_my_btn">
            <router-link
              :to="{
                        path: '/my-account/permenant',
                        params: { state: 'order' }
                      }"
            >
              <addbook2-svg></addbook2-svg>הזמנה קבועה
            </router-link>
          </div>
        </div>

        <div class="gc-promo-link">
          <router-link :to="{name: 'giftCardPurchase'}">
            <GIFTCARDICON />
            <span class="text">גיפט קארד</span>
            <span class="arrows">»</span>
          </router-link>
        </div>

      </div>
      <div class="clearfix">
        <div
          class="right menu_item"
          :class="{'no_children' : !menu_item.inner || menu_item.inner.length == 1}"
          :data-object-id="menu_item.top.object_id"
          v-for="(menu_item,index) in sortedMenu"
          :key="index"
        >
          <div class="menu_item_top ease">
            <a-div
              :href="menu_item.inner && menu_item.inner.length == 1 ? parseLink(menu_item.inner[0].top.url): menu_item.top.url ? parseLink(menu_item.top.url) : '' "
            >
                  <span v-if="!menu_item.img">{{ menu_item.top.title }}</span>
          <img v-if="menu_item.img" :src="menu_item.img" alt="">
            </a-div>
          </div>
          <div class="drop_down" v-if="menu_item.inner && menu_item.inner.length > 1">
            <arrow-down></arrow-down>
          </div>
          <div class="menu_drop">
            <div
              class="drop_img cover"
              :style="'background-image:url(' + assets +'/img/layout/drop_img.jpg);'"
            ></div>
            <div class="drop_title">      <span v-if="!menu_item.img">{{ menu_item.top.title }}</span>
          <img v-if="menu_item.img" :src="menu_item.img" alt=""></div>
            <div class="clearfix">
              <div class="right drop_col">
                <div
                  class="drop_link"
                  v-for="(menu_sub_item, index) in menu_item.inner"
                  :key="index"
                >
                  <a-div
                    v-if="getCategory(menu_sub_item.top.object_id)"
                    :href="menu_sub_item.top.url.replace(home_url,'')"
                  >{{menu_sub_item.top.title}}</a-div>
                </div>
              </div>
            </div>
            <div class="drop_sale" v-if="hasSale(menu_item.top.object_id)">
              <a
                href="#"
                @click.prevent="salesPop(getCategory(menu_item.top.object_id).sale.id)"
                v-html="getCategory(menu_item.top.object_id).sale.text"
              ></a>
            </div>
          </div>
        </div>
      </div>
      <div class="m_menu_bottom">
        <div class="m_menu_bottom_item" v-if="globalOption.customer_service_link">
          <a-div :href="parseLink(globalOption.customer_service_link.url)" :new-window="false" target="_self">
            שירות לקוחות >
            <span>
              <carmella-svg></carmella-svg>
            </span>
          </a-div>
        </div>
        <div class="m_menu_bottom_item" v-if="globalOption.delivery_link">
          <a-div :href="parseLink(globalOption.delivery_link.url)" :new-window="false" target="_self">
            משלוחים ואזורי חלוקה >
            <span>
              <ship-svg></ship-svg>
            </span>
          </a-div>
        </div>
        <div class="m_menu_bottom_item" v-if="globalOption.faq_link">
          <a-div :href="parseLink(globalOption.faq_link.url)" :new-window="false" target="_self">
            שאלות נפוצות >
            <span>
              <question-svg></question-svg>
            </span>
          </a-div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import UserSvg from "../../assets/img/user.svg";
import HeartSvg from "../../assets/img/heart.svg";
import refreshSvg from "../../assets/img/refresh.svg";
import addbook2Svg from "../../assets/img/addbook2.svg";
import ArrowDown from "../../assets/img/arrow_down.svg";
import carmellaSvg from "../../assets/img/carmella.svg";
import GIFTCARDICON from "../../assets/img/giftcard_icon.svg";
import shipSvg from "../../assets/img/shipp.svg";
import questionSvg from "../../assets/img/question.svg";
import { mapState, mapActions } from "vuex";
import store from "../../store";

export default {
  props: ["menu"],
  data() {
    return {
      wpData: wpData,
      assets: wpData.assets_url,
      home_url: wpData.home_url,
      globalOption: wpData.globalOptions
    };
  },
  computed: {
    ...mapState(["userLogged", "userLoggedInfo", "storedFavs"]),
    sortedMenu() {
      //return this.menu;
      let sort = Object.values(this.menu);
      sort.sort((a, b) => a.top.menu_order - b.top.menu_order);
      for (let index = 0; index < sort.length; index++) {
        if (sort[index].inner) {
          sort[index].inner = Object.values(sort[index].inner);
          sort[index].inner.sort((a, b) => a.top.menu_order - b.top.menu_order);
        }
      }
      return sort;
    }
  },
  watch: {
    $route(to, from) {
      if (to.path != from.path) {
        this.closeMenu();
      }
    }
  },
  mounted() {
    if($('.menu_item.no_children').length > 0){
      $.each($('.menu_item.no_children'), function (indexInArray, ele) { 
        var link = $(ele).find('.menu_drop .drop_col a').attr('href');
         if(typeof link != 'undefined'){
           $(ele).find('.menu_item_top a').attr('href',link);
         }
         
      });
    }
 
  },
  methods: {
    ...mapActions(["userLogout"]),
    closeMenu() {
      $("#mm-blocker").trigger("mousedown");
    },
    parseLink(link) {
      if (link) {
        return link.replace(this.home_url, "");
      }
      return "#";
    },
    openLogin() {
      this.closeMenu();
      this.$modal.show("login-modal", { state: "login" });
    },
    getCategory(id) {
      let category = this.$store.state.categories.find(cat => cat.id == id);
      return category;
    },
    hasSale(id) {
      let category = this.getCategory(id);
      if (category && typeof category.sale != "undefined" && category.sale) {
        return true;
      }
      return false;
    },
    saleDetails(id) {
      let sale_details = this.$store.state.sales.find(s => {
        if (s.code == id) {
          return s;
        }
      });
      return sale_details;
    },
    products(sale_id) {
      return new Promise((resolve, reject) => {
        let sale_products = Object.values(this.saleDetails(sale_id).products);
        this.$ajax({
          method: "POST",
          url: homeUrl + "ajax.php",
          params: {
            getProducts: "",
            ids: JSON.stringify(sale_products)
          }
        }).then(res => {
          resolve(res.data);
        });
      });
      /*
          let sale_products = Object.values(this.saleDetails(sale_id).products);
          let p = Array();
          sale_products.map(function(id) {
            let tmp = store.state.products.find(pr => pr.id == id);
            p.push(tmp);
          });
          return p;
          */
    },
    ...mapActions(["openPopupProduct"]),

    openProductPop(p) {
      this.openPopupProduct([p]).then(() => {
        this.$modal.show("prod-modal");
      });
    },
    salesPop(id) {
      this.products(id).then(res => {
        let products = res;
        if (products.length > 1) {
          this.$modal.show("sales-pop", {
            products: products
          });
          this.closeMenu();
        } else {
          this.openProductPop(products[0]);
          this.closeMenu();
        }
      });
      /*
          if (this.products(id).length > 1) {
            this.$modal.show("sales-pop", {
              products: this.saleDetails(id).products
            });
            this.closeMenu();
          } else {
            this.openProductPop(this.products(id)[0]);
            this.closeMenu();
          }*/
    }
  },
  components: {
    UserSvg,
    refreshSvg,
    HeartSvg,
    addbook2Svg,
    ArrowDown,
    carmellaSvg,
    shipSvg,
    questionSvg,
    GIFTCARDICON
  }
};
</script>

<style lang="sass" scoped>
  .m_login_name
    max-width: 7rem
    overflow: hidden
    text-overflow: ellipsis
    display: block
    white-space: nowrap

  .gc-promo-link a
    display: block
    background-color: rgb(243,201,195)
    margin-left: -15px
    margin-right: -15px
    margin-top: -15px
    padding: 0.4rem 0
    display: flex
    flex-wrap: nowrap
    justify-content: center
    align-items: center
    line-height: 1.5
    .new
      font-weight: bold
      color: rgb(231,70,48)
    .text
      font-weight: bold
      margin: 0 6px 0 3px
    .arrows
      color: rgb(31,47,29)
      margin: 0 3px 0 0
</style>